import { useCallback } from 'react';
import { atom, useRecoilState } from 'recoil';

export interface LoadingOverlayState {
  isLoading: boolean;
}

export const loadingOverlayState = atom<LoadingOverlayState>({
  key: 'loadingOverlayState',
  default: {
    isLoading: false,
  },
});

export const useLoadingOverlayState = () => {
  const [state, setState] = useRecoilState(loadingOverlayState);

  const setLoading = useCallback(
    (isLoading: boolean) => {
      setState({ ...state, isLoading });
    },
    [setState, state],
  );

  return { ...state, setLoading };
};
